import React, {Component} from 'react';
import _ from 'lodash';
import {fetchFeed} from '../actions';
import LatestFeedItem from './LatestFeedItem';
import { Alert, Spin, Row, Col, Icon } from 'antd';
import { routeActions } from 'react-router-redux';
import Truncate from 'react-truncate-dom';
import { Link } from 'react-router';
import { actions } from 'modules/modal';
const avatarUrl = require('./images/avatar.png');
import { logAsync } from 'helpers/elogAsync';
import qs from 'qs';

export default class LatestFeedList extends Component {

  componentDidMount() {
    const {model, dispatch, query} = this.props;
    if (_.isEmpty(model.data) && !_.isEmpty(query.subjectId)) {
      const fetchQuery = {
        ...query,
        isHighlight: false
      }
      dispatch(fetchFeed({ query: fetchQuery }));
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.query, nextProps.query)) {
      const { dispatch, query } = nextProps;
      const fetchQuery = {
        ...query,
        isHighlight: false
      }
      dispatch(fetchFeed({ query: fetchQuery }))
    }
  }

  handleClick(data) {
    const {originDispatch} = this.props;
    originDispatch(actions.toggleArticleModal(data));
  }

  handleAppend = (linkTo) => {
    // const { originDispatch, query } = this.props;
    // originDispatch(routeActions.push({
    //   pathname: '/search',
    //   query: query
    // }))
    const queryString = linkTo.split('?')[1];
    const query = qs.parse(queryString);
    document.body.scrollTop = 0;
    const {register_email} = localStorage;
    logAsync({
      type: 'sPOP-search',
      data: {
        query,
        user: register_email
      },
    })
  };

  renderFirstFacebook(data) {
    return (
      <div>
        <div className="facebook-avatar">
          <img
            src={`https://graph.facebook.com/${_.get(data, 'fromId')}/picture`}
            ref={(avatar) => {
              if (avatar) {
                avatar.onerror = () => {
                  avatar.src = avatarUrl;
                }
              }
            }}
          />
        </div>
        <div className="facebook-by">{_.get(data, 'by')}</div>
      </div>
    )
  }

  renderFirstFeed() {
    const {model, showAppend} = this.props;
    const data = _.head(_.get(model, 'data'));
    let images = [];
    let dataImages = _.get(data, 'images');
    // http://www.baby-kingdom.com/static/image/common/android_v1.gif?v=317
    _.map(dataImages, (img) => {
      const imgs = img.split('/')[6];
      let version = '';
      if (imgs !== undefined) {
        version = imgs.split('_')[0];
      }
      const versions = ['iphone', 'android'];
      if (!_.includes(versions, version)) {
        images = [...images, img];
      }
    })
    const len = images ? images.length : 0;
    if (!data) return (<div></div>);
    return (
      <div className="padding-md padding-left-xmd">
        <div>
          {len > 0 &&
            <Row>
              <Col span="11">
                <div className="first-feed-img">
                  <img src={data.images[0]} style={{height: '96px'}} />
                </div>
              </Col>
              <Col span='1'></Col>
              <Col span="12">
                <a title={data.title} onClick={(e) => {e.stopPropagation();this.handleClick(data)}}>
                  <Truncate
                    className="first-feed-title padding-top-md"
                    line={2}
                    html={data.title}
                  />
                </a>
              </Col>
            </Row>
          ||
          <a title={data.title} onClick={(e) => {e.stopPropagation();this.handleClick(data)}}>
            <Truncate
              className="first-feed-title"
              html={data.title}
            />
          </a>
          }
        </div>
        <div>
          {_.get(data, 'mediaType') == 'facebook' &&
            <div>{this.renderFirstFacebook(data)}</div>
          }
          <a onClick={(e) => {e.stopPropagation();this.handleClick(data)}}>
          <Truncate
            className="first-feed-content"
            line={7}
            html={data.content}
          />
          </a>
        </div>
      </div>
    )
  }

  render() {
    const {model, query, showAppend, hideFrom} = this.props;
    let data = _.get(model, 'data');
    if (query.limit > 5) {
      data = _.tail(_.get(model, 'data'))
    }
    let linkTo = `/search?subjectId=${query.subjectId}&mediaType=${query.mediaType}`
    if (query.sourceGroupId) {
      linkTo = `${linkTo}&sourceGroupId=${_.get(query, 'sourceGroupId')}`
    }
    return (
      <div className="feed-list margin" style={{}}>
        {model.isLoading &&
          <div style={{ textAlign: 'center' }}>
            <Spin />
          </div>
        }
        {!model.isLoading && model.count === 0 &&
          <Alert
              message={t('commonNoData')}
              description={t('commonAlertDescription')}
              type="info"
              showIcon={true}
            />
        ||
        <div>
          {query.limit > 5 &&
            <Row>
              <Col span="8">
                {this.renderFirstFeed()}
              </Col>
              <Col span="16">
                <ul>
                  {
                    _.map(data, (d, i) =>
                      <li key={i}>
                        <LatestFeedItem data={d} hideFrom={hideFrom} />
                      </li>
                    )
                  }
                </ul>
              </Col>
            </Row>
          ||
            <Row>
              <Col span='24'>
                <ul>
                  {
                    _.map(data, (d, i) =>
                      <li key={i}>
                        <LatestFeedItem data={d} hideFrom={hideFrom} />
                      </li>
                    )
                  }
                </ul>
              </Col>
            </Row>
          }
          {showAppend && _.get(model, 'data.length') < model.count &&
            <Link to={linkTo}>
              <div
                className="feed-list-append"
                onClick={(linkTo) => this.handleAppend(linkTo)}
                >
                {model.isLoading &&
                  <Icon type="loading" className="margin-right-md" />
                }
                <span>+更多</span>
              </div>
            </Link>
          }
        </div>


        }
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/feed/components/LatestFeedList.js
 **/